import { SignalDispatcher } from 'ste-signals';

export const shipmentEvents = {
  onShipmentCreated: new SignalDispatcher(),
  onShipmentDispatched: new SignalDispatcher(),
  onShipmentUnpacked: new SignalDispatcher(),
};
